import * as React from 'react';

import useModalById from '~/customHooks/useModalById';
import {MODAL_ERROR} from '~/rootStore/modals/modalsIds';

import ModalBase from '../ModalBase';
import ModalBaseContent from '../ModalBaseContent';

const ModalError: React.FC = () => {
  const {isOpen, close: onClose, props: errorModalProps} = useModalById(MODAL_ERROR);

  const {errorTitle = '', errorText = ''} = errorModalProps;

  return (
    <ModalBase open={isOpen} onClose={onClose}>
      <ModalBaseContent
        title={errorTitle}
        description={errorText}
        actionButtonText="OK"
        onClickActionButton={onClose}
      />
    </ModalBase>
  );
};

export default ModalError;
